(() => {
  $(document).on('click', '.js-answer__toggle', function () {
    $(this)
      .next('.js-answer__body')
      .stop(true, true)
      .slideToggle(200);
  });
})();